var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, Fragment } from "react/jsx-runtime";
import { UpIcon, DownIcon } from "@fluentui/react-icons-mdl2";
import { METRIC_DIRECTIONS, METRIC_WIZARD_CATEGORY, CREATE_MODAL_FIED_VALIDATION } from "./CreateModal.constants.js";
const directionIcon = (direction) => {
  switch (direction) {
    case METRIC_DIRECTIONS.Decrease:
      return /* @__PURE__ */ jsx(DownIcon, {});
    case METRIC_DIRECTIONS.Increase:
      return /* @__PURE__ */ jsx(UpIcon, {});
    default:
      return /* @__PURE__ */ jsx(Fragment, {});
  }
};
const parseMetricField = (metricField) => {
  return !!metricField ? metricField.split(",") : [];
};
const addExperienceCategory = (metadata) => {
  return __spreadProps(__spreadValues({}, metadata), {
    categories: metadata.categories.includes(METRIC_WIZARD_CATEGORY) ? metadata.categories : metadata.categories.concat(METRIC_WIZARD_CATEGORY)
  });
};
const enableMetricWizardForEditClone = (categories) => {
  return !!categories && categories.includes(METRIC_WIZARD_CATEGORY);
};
const validateInternalName = (internalName, metricNames) => {
  let errorMessage = "";
  if (!(internalName == null ? void 0 : internalName.length)) {
    errorMessage = "Required";
  } else if (!internalName.match(CREATE_MODAL_FIED_VALIDATION.internalName.pattern.value)) {
    errorMessage = CREATE_MODAL_FIED_VALIDATION.internalName.pattern.message;
  } else if (metricNames.some((name) => name === internalName)) {
    errorMessage = CREATE_MODAL_FIED_VALIDATION.internalName.duplicate;
  }
  return errorMessage;
};
export {
  addExperienceCategory,
  directionIcon,
  enableMetricWizardForEditClone,
  parseMetricField,
  validateInternalName
};
//# sourceMappingURL=CreateModal.utils.js.map
